import { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Typography,
  Box,
  Chip,
} from "@mui/material";
import { format } from "date-fns";
import Loading from "../ui/Loading";

const InvoicesDetailModal = ({
  open,
  onClose,
  filters,
  clientId,
  clientName,
  invoicesDetail,
  getInvoices,
}) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);

  useEffect(() => {
    if (open) {
      const customFilters = { ...filters };
      if (clientId) customFilters.clientId = clientId;

      getInvoices(customFilters, page + 1, rowsPerPage);
    }
  }, [open, page, rowsPerPage, filters, clientId]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const title = clientName ? `Invoices for ${clientName}` : "Invoice Details";

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        {invoicesDetail.isLoading ? (
          <Loading />
        ) : invoicesDetail.error ? (
          <Typography color="error">{invoicesDetail.error}</Typography>
        ) : (
          <>
            <TableContainer sx={{ maxHeight: 500 }}>
              <Table
                stickyHeader
                size="small"
              >
                <TableHead>
                  <TableRow>
                    <TableCell>Invoice #</TableCell>
                    <TableCell>Client</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell>Invoice Date</TableCell>
                    <TableCell>Approved Date</TableCell>
                    <TableCell align="right">Amount</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {invoicesDetail.data?.map((invoice, index) => (
                    <TableRow
                      key={index}
                      hover
                    >
                      <TableCell>{invoice.invoiceNumber || "-"}</TableCell>
                      <TableCell>{invoice.clientName || "-"}</TableCell>
                      <TableCell>
                        <Chip
                          label={invoice.status || "unknown"}
                          size="small"
                          color={
                            invoice.status === "sent"
                              ? "success"
                              : invoice.status === "approved"
                                ? "primary"
                                : "default"
                          }
                        />
                      </TableCell>
                      <TableCell>
                        {invoice.invoiceDate
                          ? format(
                              new Date(invoice.invoiceDate),
                              "MMM dd, yyyy",
                            )
                          : "-"}
                      </TableCell>
                      <TableCell>
                        {invoice.approvedAt
                          ? format(new Date(invoice.approvedAt), "MMM dd, yyyy")
                          : "-"}
                      </TableCell>
                      <TableCell align="right">
                        ${(invoice.totalAmount || 0).toLocaleString()}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

            <TablePagination
              rowsPerPageOptions={[10, 25, 50, 100]}
              component="div"
              count={invoicesDetail.total || 0}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default InvoicesDetailModal;
